import React from 'react';
import SEO from '../../../../components/SEO/SEO';

import { Link } from 'react-router-dom';
import './AllInOneLegal.css';

const AllInOneLegal = () => {
    return (
        <div className="industry-service-page">
            <SEO 
                title="All In One Legal Services | Digi Network" 
                description="Learn more about our All In One Legal services to grow your business online with Digi Network." 
                canonical="/industries/legal/services/allinonelegal" 
            />

            {/* Hero Section */}
            <section className="industry-service-hero">
                <div className="industry-service-hero-bg"></div>
                <div className="container">

                        
                    <div className="industry-service-hero-content">
                        <div className="label">ALL-IN-ONE MARKETING</div>
                        <h1>All-in-One Marketing for Legal</h1>
                        <p className="industry-service-hero-description">Get a complete, integrated marketing solution that combines SEO, paid advertising, web development, email marketing, and more. Our legal-focused all-in-one marketing helps you attract, convert, and retain clients with a unified strategy.</p>
                        <div className="industry-service-hero-cta">
                            <Link to="/contact" className="btn btn-primary">
                            Get Free Marketing Consultation
                            <svg width="25" height="23" viewBox="0 0 25 23" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <path d="M24.4766 12.1562L14.8516 21.7812C14.5234 22.1094 13.9219 22.1094 13.5938 21.7812C13.2656 21.4531 13.2656 20.8516 13.5938 20.5234L21.7422 12.375H1.125C0.632812 12.375 0.25 11.9922 0.25 11.5C0.25 11.0625 0.632812 10.625 1.125 10.625H21.7422L13.5938 2.53125C13.2656 2.20312 13.2656 1.60156 13.5938 1.27344C13.9219 0.945312 14.5234 0.945312 14.8516 1.27344L24.4766 10.8984C24.8047 11.2266 24.8047 11.8281 24.4766 12.1562Z" fill="white"/>
                            </svg>
                        </Link>
                        </div>
                    </div>
                </div>
            </section>
            {/* Stats Section */}
            <section className="seo-stats">
                <div className="container">
                    <div className="stats-grid">
                        <div className="stat-card">
                            <div className="stat-number">360°</div>
                            <div className="stat-label">Marketing Coverage</div>
                        </div>
                        <div className="stat-card">
                            <div className="stat-number">5+</div>
                            <div className="stat-label">Integrated Channels</div>
                        </div>
                        <div className="stat-card">
                            <div className="stat-number">400%</div>
                            <div className="stat-label">Average Growth</div>
                        </div>
                        <div className="stat-card">
                            <div className="stat-number">1</div>
                            <div className="stat-label">Dedicated Team</div>
                        </div>
                    </div>
                </div>
            </section>


            {/* Legal All-in-One Marketing Services */}
            <section className="industry-service-details">
                <div className="container">
                    <h2>Legal All-in-One Marketing Services</h2>
                    <p>All-in-One Marketing strategies designed specifically for legal businesses</p>

                    <div className="service-features-grid">
                        <div className="feature-card">
                            
                            <h3>Comprehensive SEO</h3>
                            <p>Dominate search results and attract organic clients with full-service SEO.</p>
                            <ul>
                                <li>Keyword research & targeting</li>
                                <li>On-page optimization</li>
                                <li>Technical SEO</li>
                                <li>Link building</li>
                                <li>Local SEO</li>
                                <li>Content marketing</li>
                            </ul>
                        </div>

                        <div className="feature-card">
                            
                            <h3>Multi-Channel Paid Advertising</h3>
                            <p>Run targeted ad campaigns across Google, Facebook, Instagram, and more.</p>
                            <ul>
                                <li>Google Ads management</li>
                                <li>Social media advertising</li>
                                <li>Display advertising</li>
                                <li>Retargeting campaigns</li>
                                <li>Video advertising</li>
                                <li>Campaign optimization</li>
                            </ul>
                        </div>

                        <div className="feature-card">
                            
                            <h3>Professional Website Development</h3>
                            <p>Build a high-converting website optimized for consultation conversions.</p>
                            <ul>
                                <li>Custom website design</li>
                                <li>Mobile-responsive development</li>
                                <li>E-commerce integration</li>
                                <li>CMS setup</li>
                                <li>Performance optimization</li>
                                <li>Ongoing maintenance</li>
                            </ul>
                        </div>

                        <div className="feature-card">
                            
                            <h3>Email Marketing Automation</h3>
                            <p>Nurture leads and drive repeat consultation conversions with automated email campaigns.</p>
                            <ul>
                                <li>Email strategy development</li>
                                <li>Template design</li>
                                <li>List building & segmentation</li>
                                <li>Automation workflows</li>
                                <li>Campaign analytics</li>
                                <li>A/B testing</li>
                            </ul>
                        </div>

                        <div className="feature-card">
                            
                            <h3>Social Media Management</h3>
                            <p>Build your brand and engage with your audience across social media platforms.</p>
                            <ul>
                                <li>Content creation</li>
                                <li>Social media posting</li>
                                <li>Community management</li>
                                <li>Influencer outreach</li>
                                <li>Social advertising</li>
                                <li>Performance analytics</li>
                            </ul>
                        </div>

                        <div className="feature-card">
                            
                            <h3>Analytics & Reporting</h3>
                            <p>Track all marketing channels in one unified dashboard with comprehensive reporting.</p>
                            <ul>
                                <li>Multi-channel analytics</li>
                                <li>ROI tracking</li>
                                <li>Conversion attribution</li>
                                <li>Custom dashboards</li>
                                <li>Monthly reports</li>
                                <li>Strategy recommendations</li>
                            </ul>
                        </div>
                    </div>
                </div>
            </section>
            {/* Why Choose Section */}
            <section className="why-seo-matters">
                <div className="container">
                    <div className="section-header">
                        <h2>Why Choose Our All-in-One Marketing Services</h2>
                        <p>Discover what makes our all-in-one marketing services stand out from the competition</p>
                    </div>
                    <div className="why-seo-points">
                        <div className="why-point">
                            <h4>🎯 Unified Strategy</h4>
                            <p>All marketing channels work together seamlessly for maximum impact and efficiency.</p>
                        </div>
                        <div className="why-point">
                            <h4>💰 Cost Savings</h4>
                            <p>More cost-effective than hiring multiple agencies or building an in-house team.</p>
                        </div>
                        <div className="why-point">
                            <h4>⚡ Faster Results</h4>
                            <p>Launch all marketing initiatives simultaneously for accelerated growth.</p>
                        </div>
                        <div className="why-point">
                            <h4>📊 Single Dashboard</h4>
                            <p>Monitor all your marketing metrics in one place with unified reporting.</p>
                        </div>
                    </div>
                </div>
            </section>
            {/* Process Section */}
            <section className="seo-process">
                <div className="container">
                    <div className="section-header">
                        <div className="label">OUR APPROACH</div>
                        <h2>Our All-in-One Marketing Process</h2>
                        <p>A proven methodology designed specifically for legal businesses</p>
                    </div>

                    <div className="process-grid">
                        <div className="process-step">
                            <div className="process-number">01</div>
                            <h3>Complete Analysis</h3>
                            <p>Audit all aspects of your marketing to identify opportunities across channels.</p>
                        </div>
                        <div className="process-step">
                            <div className="process-number">02</div>
                            <h3>Integrated Strategy</h3>
                            <p>Develop a unified marketing plan that leverages all channels synergistically.</p>
                        </div>
                        <div className="process-step">
                            <div className="process-number">03</div>
                            <h3>Multi-Channel Launch</h3>
                            <p>Execute campaigns across all platforms simultaneously for maximum impact.</p>
                        </div>
                        <div className="process-step">
                            <div className="process-number">04</div>
                            <h3>Unified Optimization</h3>
                            <p>Monitor all channels, optimize performance, and scale successful strategies.</p>
                        </div>
                    </div>
                </div>
            </section>



            {/* Legal All-in-One Marketing Process */}

            {/* CTA Section */}
            <section className="industry-service-cta">
                <div className="container">
                    <h2>Ready to Transform Your Marketing?</h2>
                    <p>Get a free comprehensive marketing consultation and discover how our all-in-one solution can help you dominate your market.</p>
                    <Link to="/contact" className="btn btn-primary">
                        Get Free Marketing Consultation
                        <svg width="25" height="23" viewBox="0 0 25 23" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path d="M24.4766 12.1562L14.8516 21.7812C14.5234 22.1094 13.9219 22.1094 13.5938 21.7812C13.2656 21.4531 13.2656 20.8516 13.5938 20.5234L21.7422 12.375H1.125C0.632812 12.375 0.25 11.9922 0.25 11.5C0.25 11.0625 0.632812 10.625 1.125 10.625H21.7422L13.5938 2.53125C13.2656 2.20312 13.2656 1.60156 13.5938 1.27344C13.9219 0.945312 14.5234 0.945312 14.8516 1.27344L24.4766 10.8984C24.8047 11.2266 24.8047 11.8281 24.4766 12.1562Z" fill="white"/>
                        </svg>
                    </Link>
                </div>
            </section>
        </div>
    );
};

export default AllInOneLegal;
